import React, { FC } from 'react';

export type Props = React.HTMLAttributes<HTMLDivElement> & {
  index: number;
  value: number;
};

/**
 * @deprecated
 * @example
 *
 * Prefer `@material-ui/lab/TabPanel`.
 * Note: MUI's TabPanel is not a 1:1 replacement for this component. MUI's Tabpanel requires
 * a MUI TabContext. See docs for examples:
 * https://v4.mui.com/components/tabs/#experimental-api
 *
 */

export const TabPanel: FC<Props> = ({ children, value, index, ...rest }) => (
  <div aria-labelledby={`tab-${index}`} hidden={value !== index} id={`tabpanel-${index}`} role="tabpanel" {...rest}>
    {value === index && children}
  </div>
);

export default TabPanel;
